var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Hasklig-Regular;src:url(" + escape(require("./Hasklig-Regular.woff2")) + ") format(\"woff2\"),url(" + escape(require("./Hasklig-Regular.woff")) + ") format(\"woff\");font-weight:400;font-style:normal}", ""]);

// exports
